import React from 'react';
import cn from 'classnames';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import SearchingNewsList from './SearchingNewsList';
import Paper from '@material-ui/core/Paper';
import SearchBarButton from './SearchBarButton';

interface Props {
  className?: string;
}

export type News = {
  title: string;
  link: string;
  originallink: string;
  description: string;
  pubDate: string;
};

const NewsContainer: React.FC<Props> = React.memo(({ className }) => {
  const [newsList, setNewsList] = React.useState<Array<News>>([]);
  const [keyWord, setKeyWord] = React.useState<string | undefined>('삼성전자');
  const [isShowNews, setIsShowNews] = React.useState<boolean>(false);
  const [temp, setTemp] = React.useState<string | undefined>(undefined);
  const [sort, setSort] = React.useState<string>('sim');

  React.useEffect(() => {
    if (keyWord !== undefined) {
      getKeyWordNews(keyWord, sort);
    }
  }, [keyWord, sort]);

  const getKeyWordNews = async (query: string | null, sort: string) => {
    if (query !== null) {
      const response = await fetch(
        `http://localhost:8080/api/finance/news/${query}?sort=${sort}`,
      );

      if (!response.ok) {
        window.alert('get failed');
      }
      const resJson = await response.json();

      setNewsList(resJson.items);
      console.log(resJson);
      console.log('getNewsList!');
    }
  };

  const onChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => {
    setTemp(e.target.value);
    setIsShowNews(true);
  };

  const keyEventHandler = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter') {
      if (temp !== '') {
        setKeyWord(temp);
        setTemp(undefined);
      }
    }
    if (e.key === 'Escape' || e.key === 'ArrowUp') {
      setIsShowNews(false);
    }
    if (e.key === 'ArrowDown') {
      setIsShowNews(true);
    }
  };

  return (
    <Paper elevation={4} className={cn(className)}>
      <div className="flex">
        <TextField
          style={{ padding: '0px 16px' }}
          fullWidth
          onKeyDown={keyEventHandler}
          onChange={onChange}
          placeholder="NEWS"
          value={temp}
          margin="dense"
        />
        <Button
          onClick={() => {
            setKeyWord(temp);
            setTemp(undefined);
            setIsShowNews(true);
          }}
          disabled={temp === ''}>
          검색
        </Button>
      </div>
      <Paper elevation={1}>
        <div
          className={`${
            isShowNews === true ? 'opacity-100 max-h-auto' : 'opacity-0 max-h-0'
          } transition:max-height duration-700 md:h-96 h-52 px-2 overflow-y-scroll`}>
          {newsList.map((arr, key) => {
            return (
              <div key={'news' + key}>
                <SearchingNewsList
                  className="text-lg py-1 flex justify-center lg:space-x-5 space-x-3"
                  arr={arr}
                />
              </div>
            );
          })}
        </div>
      </Paper>
      {isShowNews && (
        <SearchBarButton
          sort={sort}
          latest={() => setSort('date')}
          relevance={() => setSort('sim')}
          clickCancle={() => setIsShowNews(false)}
        />
      )}
    </Paper>
  );
});

export default NewsContainer;
